
import { globalStyles } from '../../../assets/globalStyles';
import React, { ReactElement } from 'react';
import { Lens, Info } from '@material-ui/icons';
import {
    Box,
    Grid,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

export default function LegendePQIndex(): ReactElement {

    const classes = {
        ...globalStyles(),
    };


    const [openLegendeDialog, setOpenLegendeDialog] = React.useState(false);

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "5px" }}>
                <Button
                    component={"div"}
                    onClick={() => {
                        openLegendeDialog ? setOpenLegendeDialog(false) : setOpenLegendeDialog(true)
                    }}
                    style={{ minWidth: "unset", marginLeft: "20px", color: "rgb(177, 177, 177)" }}
                >Legende
                    <Info style={{ marginLeft: "10px" }} />
                </Button>
                <Dialog open={openLegendeDialog} onClose={() => setOpenLegendeDialog(false)}>
                    <DialogTitle>Legende PQ Index</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Box display="flex" flexDirection="row" p={1} m={1} style={{ marginBottom: "-10px" }}>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Lens style={{ color: "#99cc99" }} /></Box>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Typography>Wert zwischen 0.5 und 1.0</Typography></Box>
                            </Box>
                            <Box display="flex" flexDirection="row" p={1} m={1} style={{ marginBottom: "-10px" }}>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Lens style={{ color: "#ffd27f" }} /></Box>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Typography >Wert zwischen 0.0 und 0.5</Typography></Box>
                            </Box>
                            <Box display="flex" flexDirection="row" p={1} m={1} style={{ marginBottom: "-10px" }}>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Lens style={{ color: "#e39999" }} /></Box>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Typography >Wert zwischen 0.0 und - ∞</Typography></Box>
                            </Box>
                            <Box display="flex" flexDirection="row" p={1} m={1} style={{ marginBottom: "-10px" }}>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Lens style={{ color: "#eeeeee" }} /></Box>
                                <Box p={1} style={{ marginBottom: "-10px" }}><Typography >Keine Daten</Typography></Box>
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => setOpenLegendeDialog(false)}
                            className={classes.cancleDeleteButton}
                        >
                            Schliessen
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </React.Fragment>
    )
}
